import { colorSystem } from '@/styles/theme'
import { ForwardedRef, forwardRef, HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

interface DividerProps extends HTMLAttributes<HTMLDivElement> {
  color?: string
  variant?: 'horizontal' | 'vertical'
}

function _Divider(
  { color = colorSystem.border.divider, variant = 'horizontal', ...htmlDivProps }: DividerProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return <DividerWrap ref={ref} color={color} variant={variant} {...htmlDivProps} />
}

const DividerWrap = styled.div<NonNullable<Pick<DividerProps, 'variant' | 'color'>>>`
  background-color: ${({ color }) => color};

  ${({ variant }) =>
    variant === 'horizontal'
      ? css`
          width: 100%;
          height: 1px;
        `
      : css`
          width: 1px;
          height: 100%;
        `}
`

export const Divider = forwardRef(_Divider)
